import { getShopWidgetConfigs } from '../../components/Sections/ShopSection/shopWidgetConfigs';
import {
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
} from './common';

export function getShopSectionInitActions(responseData, requestParams) {
  return getCommonSectionInitActions(
    responseData,
    requestParams,
    'shop'
  ).filter(action => action);
}

// new grusers
export const getCustomInitActionsForShopWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getShopWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
];
